<div class="containar-layout team-section" *ngIf="teamDetails.length">
  <table class="table-section">
    <thead>
      <tr>
        <th class="column-head custom-border" translate>label_shift_team_text<span class="sort-icon" (click)="sortTeams()"><i class="fa fa-sort" style="color: #32455F;"></i></span></th>
        <th class="column-head" *ngFor="let teamShiftDetail of teamDetails[0]?.teamShiftDetails">
          {{teamShiftDetail?.dateStr | weekMonthDate}}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let shiftDetail of teamDetails">
        <td class="column-body"><ng-container *ngTemplateOutlet="teamHeader; context: shiftDetail"></ng-container></td>
        <td class="column-body" *ngFor="let teamShiftDetail of shiftDetail?.teamShiftDetails">
          <app-team-weekly-slot-card [isOpenShiftPermission]="isOpenShiftPermission"
            [teamShiftDetail]="teamShiftDetail" [providerId]="shiftDetail?.providerId" [id]="shiftDetail?.id"
            (openShiftPopup)="openShift($event)" [isPastDate]="isPastDate"></app-team-weekly-slot-card></td>
      </tr>
    </tbody>
  </table>
</div>
<div class="no-records-wrapper" *ngIf="!teamDetails.length" translate>label_shift_no_records_available</div>

<ng-template #teamHeader let-teamName="teamName" let-teamShifts="teamShifts">
  <div class="team-header-wrappper">
    <h4 class="title-heading">{{teamName}}</h4>
    <div class="text team-header-inner-wrappper" *ngFor="let teamShift of manageTeamShifts(teamShifts)">
      <span [pTooltip]="teamShift?.shiftSchedule.length > 25 ? teamShift?.shiftSchedule : null">{{teamShift?.shiftSchedule.length > 25 ? teamShift?.shiftSchedule.slice(0,22) + '...' : teamShift?.shiftSchedule}}</span>
      <span>{{teamShift?.startTimeStr}}-{{teamShift?.endTimeStr}}</span>
      <span *ngIf="+teamShift?.startDate != -1">Starts on: {{teamShift?.startDateTimeStr}}</span>
      <span *ngIf="+teamShift?.endDate != -1">Ends on: {{teamShift?.endDateTimeStr}}</span>
    </div>
    <span class="text blue-text" *ngIf="teamShifts.length > 2"
      (click)="toggleOverviewPanel($event, teamShifts)" translate>label_shift_more</span>
  </div>
</ng-template>

<p-dialog [blockScroll]="true" modal="true" [showHeader]="false" position="center" responsive="true"
  [style]="{width: '450px', height: 'auto'}" styleClass="add-routes-popup" [(visible)]="hasShowPublishShiftPopUp"
  responsive="true" ng-style="overflow: auto" [contentStyle]="{'overflow':'auto'}">
  <app-publish-open-shift (publishOpenShiftEmitter)="onClickOfPopupButton($event)" [selectedTeam]="selectedTeam"
    [selectedDate]="selectedDate"></app-publish-open-shift>
</p-dialog>

<p-overlayPanel class="grid-overlay-panel" [showCloseIcon]="true" #op>
  <div class="text team-header-inner-wrappper" *ngFor="let teamShift of teamShiftsList">
    <div class="slot-main-wrapper">
      <span class="text team-schedule">{{teamShift?.shiftSchedule}}</span>
      <span class="text">{{teamShift?.startTimeStr}}-{{teamShift?.endTimeStr}}</span>
    </div>
    <div class="custom-date-wrapper" *ngIf="+teamShift?.endDate != -1">
      <span class="text bold" translate>label_shift_ends_on</span>
      <span class="text">{{teamShift?.endDateTimeStr}}</span>
    </div>
  </div>
</p-overlayPanel>